import React from 'react';
import '../../styles/main.scss';

const Footer = () => {
  return (
     <footer className="footer">
      <div className="footer-left">
        <p className="footer-copyright">© 2026 iBEAM. All rights reserved.</p>
      </div>
      
      <div className="footer-right">
        <a href="#" className="footer-link">Privacy Policy</a>
        <a href="#" className="footer-link">Terms of Service</a>
        <a href="#" className="footer-link">Support</a>
      </div>
    </footer>
  );
};

export default Footer;